import Vue from "vue"

function contains(vue, dom) {
  while (dom && !dom.__vue__) dom = dom.parentElement
  if (!dom) return true // 控件此时如果已被删除，特殊处理
  let tVue = dom?.__vue__

  while (tVue && tVue != vue) tVue = tVue.$parent
  return tVue == vue
}

// 目前只可以用于组件（直接作用于dom可能会判断不准，因为目前是根据vnode来判断包含关系的）
Vue.directive("click-outside", {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      // here I check that click was outside the el and his children
      if (!contains(vnode.context, event.target)) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener("click", el.clickOutsideEvent)
  },
  unbind: function(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent)
  }
})
